<template>
    <div class="shipment-open-report">
        <ShipmentOpenReportFilters
            :date-from="filters.dateFrom"
            :date-to="filters.dateTo"
            :manager-ids="filters.managerIds"
            :is-loading="isLoading"
            @filters-change="onFiltersChange"
            @reload="onReload"
        />

        <ShipmentOpenReportTotals
            :total-price="reportData.total_price"
            :total-paid="reportData.total_paid"
            :total-outstanding-balance="reportData.total_outstanding_balance"
        />

        <ShipmentOpenReportTable :wigs="reportData.wigs" :is-loading="isLoading" />

        <v-pagination
            v-if="pagination && pagination.lastPage > 1"
            v-model="page"
            class="pagination"
            :total-visible="7"
            :length="pagination.lastPage"
            color="#3bafda"
            @input="onPageChange"
        ></v-pagination>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { actionTypes, getterTypes } from '@/store/modules/shipments'
import ShipmentOpenReportFilters from './shipment-open-report-filters.vue'
import ShipmentOpenReportTotals from './shipment-open-report-totals.vue'
import ShipmentOpenReportTable from './shipment-open-report-table.vue'

export default {
    name: 'ShipmentOpenReport',
    components: {
        ShipmentOpenReportFilters,
        ShipmentOpenReportTotals,
        ShipmentOpenReportTable,
    },
    data() {
        return {
            filters: {
                dateFrom: '',
                dateTo: '',
                managerIds: [],
                perPage: 15,
            },
            page: 1,
        }
    },
    computed: {
        ...mapGetters('shipments', {
            openShipmentReport: getterTypes.getOpenShipmentReport,
            isFetchingOpenReport: getterTypes.isFetchingOpenReport,
        }),
        isLoading() {
            return this.isFetchingOpenReport
        },
        reportData() {
            return {
                wigs: this.openShipmentReport.wigs || [],
                total_price: this.openShipmentReport.total_price || 0,
                total_paid: this.openShipmentReport.total_paid || 0,
                total_outstanding_balance:
                    this.openShipmentReport.total_outstanding_balance || 0,
            }
        },
        pagination() {
            return this.openShipmentReport.pagination || null
        },
    },
    mounted() {
        this.initializeDates()
        this.fetchReport()
    },
    methods: {
        ...mapActions('shipments', {
            fetchOpenShipmentReport: actionTypes.fetchOpenShipmentReport,
        }),
        initializeDates() {
            const date = new Date()
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const today = `${year}-${month}-${day}`

            this.filters.dateFrom = '2026-01-01'
            this.filters.dateTo = today
        },
        buildApiParams() {
            const params = {
                page: this.page,
                per_page: this.filters.perPage,
            }

            if (this.filters.dateFrom) {
                params.date_from = this.filters.dateFrom
            }

            if (this.filters.dateTo) {
                params.date_to = this.filters.dateTo
            }

            if (this.filters.managerIds && this.filters.managerIds.length > 0) {
                params.manager_ids = this.filters.managerIds
            }

            return params
        },
        fetchReport() {
            const params = this.buildApiParams()
            this.fetchOpenShipmentReport(params)
        },
        onFiltersChange(newFilters) {
            this.filters = {
                ...newFilters,
                perPage: 15,
            }
            this.page = 1
            this.fetchReport()
        },
        onReload() {
            this.fetchReport()
        },
        onPageChange(page) {
            this.page = page
            this.fetchReport()
        },
    },
}
</script>

<style lang="scss" scoped>
.shipment-open-report {
    width: 100%;

.pagination {
    padding: 8px 0 0 0 !important;
}
}
</style>

